import AccordeonHeaders from './AccordeonHeaders';

export default function Accordeon() {
  // раскрытие\скрытие по нажатию
  const header = document.querySelectorAll('.accordeon__header');

  AccordeonHeaders(header);

  // табы
  const tabsBtn = document.querySelectorAll('.cities .tabs-container .tab');

  if (tabsBtn) {
    tabsBtn.forEach((tab) => {
      tab.addEventListener('click', function onClick() {
        const parentSection = this.closest('.accordeon__item');
        const block = parentSection.querySelector(`#${this.dataset.tab}`);
        if (!block) {
          return;
        }
        const show = parentSection.querySelector('.show');
        if (show) {
          show.classList.remove('show');
        }
        parentSection.querySelector('.tab-active').classList.remove('tab-active');
        this.classList.add('tab-active');
        block.classList.add('show');
      });
    });
  }

  // анкорные ссылки
  const btnsCities = document.querySelectorAll('[data-city]');
  if (btnsCities) {
    btnsCities.forEach((btn) => {
      btn.addEventListener('click', () => {
        const parent = btn.closest('.accordeon__item.active');
        if (parent) {
          window.location.hash = btn.dataset.city;
        }
      });
    });
  }
}
